export namespace PasswordComplexityValidation  {
    export interface PasswordComplexityValidator {
        isAcceptable(s: any): boolean;
    } 

    export class MinimumLengthValidator {
        isAcceptable(result: string, minimumLength: number): boolean {
            return ((result.length >= minimumLength) ? true : false);
        }
    }

    export class MaximumLengthValidator {
        isAcceptable(result: string, minimumLength: number, maximumLength: number): boolean {
            return ((result.length >= minimumLength && result.length <= maximumLength) ? true : false);
        }
    }

    export class SpecialCharacterValidator {
        isAcceptable(result: string, specialCharacterRegex: any): boolean {
            return ((specialCharacterRegex.test(result)) ? true : false);
        }
    }

    export class NumberAllowedValidator {
        isAcceptable(result: string): boolean {
            const NumberOnlyRegex = /\d/g;
            return ((NumberOnlyRegex.test(result)) ? true : false);
        }
    }
    
    export class UpperCaseValidator {
        isAcceptable(result: string): boolean {
            const UpperCaseRegex = /[A-Z]/g;
            return ((UpperCaseRegex.test(result)) ? true : false);
        }
    }
    export class LowerCaseValidator {
        isAcceptable(result: string): boolean {
            const LowerCaseRegex = /[a-z]/g;
            return ((LowerCaseRegex.test(result)) ? true : false);
        }
    }
}